import { render, staticRenderFns } from "./SeatsChart.vue?vue&type=template&id=17842fbe&"
import script from "./SeatsChart.vue?vue&type=script&lang=js&"
export * from "./SeatsChart.vue?vue&type=script&lang=js&"
import style0 from "./SeatsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports